"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var is_number_1 = require("./is-number");

var isEven = function isEven(num) {
  return is_number_1.default(num) && num % 2 === 0;
};

exports.default = isEven;